var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem"}]},[_c('settings-header',[_vm._v("\n        Devices\n    ")]),_c('settings-section',[_c('settings-header',{attrs:{"el":"h4"}},[_vm._v("\n            Coming soon\n        ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }